module.exports = __webpack_public_path__ + "static/media/eye-open.13bf9e0a.svg";